export interface EmulatorGoogleIdentity {
  email: string;
  name?: string;
}

export type AuthAction = () => Promise<unknown>;
export type DevSignInAction = (
  identity: EmulatorGoogleIdentity,
) => Promise<unknown>;

export function errorCode(error: unknown): string | null {
  if (typeof error !== "object" || error === null || !("code" in error)) {
    return null;
  }
  return typeof error.code === "string" ? error.code : null;
}

export function errorDetail(error: unknown): string {
  if (typeof error !== "object" || error === null) return "unknown error";
  if ("code" in error && typeof error.code === "string") return error.code;
  if ("message" in error && typeof error.message === "string") {
    return error.message;
  }
  return "unknown error";
}
